import type { ReactNode } from 'react';
import { CardTable } from './CardTable.js';

/**
 * The felt for draw-and-discard games with one to three opponents: one sits across (top), two take
 * the sides, three take the usual West / North / East places (by seat id when those are the seats);
 * `center` is the piles and melds, `bottom` you and your hand.
 */
export function OpponentTable({
  opponents,
  center,
  bottom,
}: {
  readonly opponents: readonly { readonly seat: string; readonly node: ReactNode }[];
  readonly center: ReactNode;
  readonly bottom: ReactNode;
}) {
  const bySeat = (id: string) => opponents.find((o) => o.seat === id)?.node;
  const named = opponents.length === 3 && bySeat('W') && bySeat('N') && bySeat('E');
  const [a, b, c] = opponents.map((o) => o.node);
  const top = named ? bySeat('N') : opponents.length === 2 ? null : opponents.length === 3 ? b : a;
  const left = named ? bySeat('W') : opponents.length >= 2 ? a : null;
  const right = named ? bySeat('E') : opponents.length === 2 ? b : opponents.length === 3 ? c : null;
  return <CardTable top={top} left={left} right={right} center={center} bottom={bottom} />;
}
